import React from "react";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
}

const Input: React.FC<InputProps> = ({ className = "", ...props }) => {
    return (
        <input
            className={
                "w-full h-12 px-4 rounded-xl border border-gray-300 text-md focus:border-clip-500 focus:ring-2 focus:ring-clip-300 outline-none transition " +
                className
            }
            {...props}
        />
    );
};

export default Input;